import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { UserModel } from './shared/user.model';
import { LoggerService } from './logger.service';
var ApiRoot = (function () {
    function ApiRoot(authUser, loggerService) {
        this.loggerService = loggerService;
        this.baseUrl = 'http://localhost:8080/';
        this.siteId = '48190c8c-42c4-46af-8d1a-0cd5db894797';
        this.hideFireOn = false;
        this.hideRulePushOptions = false;
        this.authUser = authUser;
        this.authToken = ApiRoot.createAuthToken(authUser);
        try {
            var query = document.location.search.substring(1);
            if (query === '') {
                if (document.location.hash.indexOf('?') >= 0) {
                    query = document.location.hash.substr(document.location.hash.indexOf('?') + 1);
                }
            }
            var siteId = ApiRoot.parseQueryParam(query, 'realmId');
            if (siteId) {
                this.siteId = siteId;
                this.loggerService.debug('Site Id set to ', this.siteId);
            }
            var hideFireOn = ApiRoot.parseQueryParam(query, 'hideFireOn');
            if (hideFireOn) {
                this.hideFireOn = hideFireOn === 'true' || hideFireOn === '1';
                this.loggerService.debug('hideFireOn set to ', this.hideFireOn);
            }
            var hideRulePushOptions = ApiRoot.parseQueryParam(query, 'hideRulePushOptions');
            if (hideRulePushOptions) {
                this.hideRulePushOptions =
                    hideRulePushOptions === 'true' || hideRulePushOptions === '1';
                this.loggerService.debug('hideRulePushOptions set to ', this.hideRulePushOptions);
            }
            var baseUrl = ApiRoot.parseQueryParam(query, 'baseUrl');
            this.loggerService.debug('Proxy server Base URL set to ', baseUrl);
            this.setBaseUrl(baseUrl); // if null, just uses the base of the current URL
            this.configureUser(query, authUser);
        }
        catch (e) {
            this.loggerService.error('Could not set baseUrl automatically.', e);
        }
    }
    ApiRoot.createAuthToken = function (authUser) {
        var token = null;
        if (authUser && authUser.username && authUser.password) {
            token = 'Basic ' + btoa(authUser.username + ':' + authUser.password);
        }
        return token;
    };
    ApiRoot.parseQueryParam = function (query, token) {
        var idx = -1;
        var result = null;
        token = token + '=';
        if (query && query.length) {
            idx = query.indexOf(token);
        }
        if (idx >= 0) {
            var end = query.indexOf('&', idx);
            end = end !== -1 ? end : query.length;
            result = query.substring(idx + token.length, end);
        }
        return result;
    };
    ApiRoot.prototype.getDefaultRequestHeaders = function () {
        var headers = new Headers();
        headers.append('com.dotmarketing.session_host', this.siteId);
        headers.append('Accept', '*/*');
        // headers.append('Accept', 'application/json');
        // headers.append('Content-Type', 'application/json,text/html');
        if (this.authToken) {
            headers.append('Authorization', this.authToken);
        }
        return headers;
    };
    ApiRoot.prototype.getDefaultRequestOptions = function () {
        var headers = new Headers();
        headers.append('com.dotmarketing.session_host', this.siteId);
        if (this.authToken) {
            headers.append('Authorization', this.authToken);
        }
        headers.append('Content-Type', 'application/json');
        return new RequestOptions({
            headers: headers
        });
    };
    ApiRoot.prototype.setBaseUrl = function (url) {
        if (url === void 0) { url = null; }
        if (url === null) {
            // set to same as current request
            var loc = document.location;
            this.baseUrl = loc.protocol + '//' + loc.host + '/';
        }
        else if (url && url.startsWith('http://' || url.startsWith('https://'))) {
            this.baseUrl = url.endsWith('/') ? url : url + '/';
        }
        else {
            throw new Error('Invalid proxy server base url: \'' + url + '\'');
        }
        this.defaultSiteUrl = this.baseUrl + 'api/v1/sites/' + this.siteId;
    };
    ApiRoot.prototype.configureUser = function (query, user) {
        user.suppressAlerts = ApiRoot.parseQueryParam(query, 'suppressAlerts') === 'true';
    };
    return ApiRoot;
}());
export { ApiRoot };
ApiRoot.decorators = [
    { type: Injectable },
];
/** @nocollapse */
ApiRoot.ctorParameters = function () { return [
    { type: UserModel, },
    { type: LoggerService, },
]; };
//# sourceMappingURL=api-root.service.js.map